import React from 'react';

import { isEqual, omit } from 'lodash-es';
import { InjectedIntl, injectIntl } from 'react-intl';
import { useSelector, useDispatch } from 'react-redux';

import Button from '@atlaskit/button/standard-button';

import { changeFilterState } from 'src/redux/jira/actions';
import { emptyFilterState } from 'src/redux/jira/reducers/jira-repo-page';
import { getFilterState } from 'src/redux/jira/selectors/repo-page-selectors';
import { FilterState } from 'src/redux/jira/types';

import messages from './clear-filters-button.18n';

type ClearFiltersButtonProps = {
  intl: InjectedIntl;
};

const omitUnwantedFields = (filterState: FilterState) =>
  omit<FilterState, keyof FilterState>(filterState, [
    'siteCloudId',
    'sort',
    'currentPage',
  ]);

export const ClearFiltersButton = injectIntl(
  (props: ClearFiltersButtonProps) => {
    const filterState = useSelector(getFilterState);
    const dispatch = useDispatch();
    const { intl } = props;

    if (
      isEqual(
        omitUnwantedFields(filterState),
        omitUnwantedFields(emptyFilterState)
      )
    ) {
      return null;
    }

    return (
      <Button
        appearance="subtle"
        onClick={() =>
          dispatch(changeFilterState(omitUnwantedFields(emptyFilterState)))
        }
      >
        {intl.formatMessage(messages.clearFiltersButton)}
      </Button>
    );
  }
);
